var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",attrs:{"style-override":_vm.styleOverride}},[_c('router-view'),_c('v-snackbar-queue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }